"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCookie = exports.getCookie = void 0;
const getCookie = (cookieName) => {
    const name = cookieName + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const allCookies = decodedCookie.split(';');
    for (let i = 0; i < allCookies.length; i++) {
        let cookie = allCookies[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
};
exports.getCookie = getCookie;
const setCookie = ({ cookieName, value, expires = 'never', }) => {
    const maxAge = (() => {
        if (expires === 'never') {
            return 60 * 60 * 24 * 365;
        }
        else if (expires === 'session') {
            return 0;
        }
        else {
            return (new Date(expires).valueOf() - new Date().valueOf()) / 1000;
        }
    })();
    document.cookie = `${cookieName}=${JSON.stringify(value)};max-age=${maxAge};path=/`;
};
exports.setCookie = setCookie;
